<div class="main-container">
    <div class="main-table">
        <div class="table-header row">
            <div class="col-2"></div>            
            <div class="col text-center" *ngFor="let input of possibleConsumptionInputKeys">{{ input | translate }}</div>            
        </div>
        <div class="table-body">
            
            <ng-container *ngIf="singleMonthConsumptionInput; then consumptionsInputSingleMonth; else consumptionsInputMultiMonth"></ng-container>
            
            <ng-template #consumptionsInputSingleMonth>
                <form [formGroup]="singleMonthInputFormGroup" *ngIf="singleMonthInputFormGroup">
                    <div class="row my-5">
                        <div class="col-2 align-content-center"> 
                            <!-- <input type="month" formControlName="date"> -->
                            <is-date-time-picker formControlName="date" [dateFormat]="'MMMM YYYY'" [Type]="datepickerType" [clearDatesBtn]="false"></is-date-time-picker>
                        </div>
                        <div class="col" *ngFor="let input of possibleConsumptionInputValues; let i1 = index">
                            <div class="input-group input-group-sm">
                                <input type="number" class="form-control form-control-sm form-control-solid border-end" [formControlName]='input'>
                                <span class="input-group-text">kWh</span>
                            </div>
                        </div>
                    </div>
                </form>
            </ng-template>

            <ng-template #consumptionsInputMultiMonth>
                <ng-container *ngFor="let consumptionsForm of consumptionsFormArray.controls; let i = index; let isLast = last">
                    <form [formGroup]="consumptionsForm">
                        <div class="row my-5">
                            <div class="col-2 align-content-center"> 
                                {{consumptionsForm.controls.date.value | date: 'MMMM YYYY': undefined: 'pt-PT'}}
                            </div>
                            <div class="col" *ngFor="let input of possibleConsumptionInputValues; let i1 = index">
                                <div class="input-group input-group-sm">
                                    <input type="number" class="form-control form-control-sm form-control-solid border-end" [formControlName]='input' (paste)="copyPasteHandler(i, i1, $event)">
                                    <span class="input-group-text">kWh</span>
                                </div>
                            </div>
                        </div>
                    </form>
                    
                    <div *ngIf="!isLast || allowsPriceInput" class="dashed-hr"></div>
                </ng-container>
            </ng-template>

            <form [formGroup]="parentFormGroup" *ngIf="parentFormGroup && allowsPriceInput">
                <div class="row my-5">
                    <div class="col-2 align-content-center"> 
                        {{ 'UNIT_PRICE_PER_KWH' | translate }}
                    </div>
                    <div class="col" *ngFor="let input of possiblePriceInputValues; let i1 = index">
                        <div class="input-group input-group-sm">
                            <input type="number" class="form-control form-control-sm form-control-solid border-end" [formControlName]='input'>
                            <span class="input-group-text">€</span>
                        </div>
                    </div>
                </div>
            </form>

            <div class="solid-hr mb-5"></div>

            <div class="row gy-5">
                <div class="col-2 align-content-center"> {{ 'ESTIMATED_TOTAL' | translate }}</div>
                <div class="col">
                    <div class="input-group input-group-sm">
                        <input type="number" class="form-control form-control-sm form-control-solid border-end" disabled [value]="sumTotal">
                        <span class="input-group-text disabled-input">kWh</span>
                    </div>
                    
                </div>
            
                <div class="col" *ngIf="allowsPriceInput">
                    <div class="input-group input-group-sm">
                        <input type="number" class="form-control form-control-sm form-control-solid border-end" disabled [value]="priceSumTotal">
                        <span class="input-group-text disabled-input">€</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>